<template>
    <div>
        <select multiple :name="name" class="is-hidden">
            <option
                v-for="option in value"
                :key="option.value"
                :value="option.value"
                selected
            >{{ option.label }}</option>
        </select>

        <vue-multiselect
            ref="multiselect"
            v-model="value"
            :options="options"
            :multiple="true"
            :close-on-select="true"
            :clear-on-select="true"
            :preserve-search="true"
            :placeholder="placeholder"
            :selected-label="selectedLabel"
            :select-label="selectLabel"
            :deselect-label="deselectLabel"
            label="label"
            track-by="value"
        />
    </div>
</template>



<script>
import VueMultiselect from 'vue-multiselect'
import Korg from '../../vendors/korg'




export default {

    /* Settings
    --------------------------------------------------------- */

    name: 'Multiselect',


    components: {
        VueMultiselect,
    },


    props: {
        placeholder: { type: String, required: true },
        name: { type: String, required: true },
        options: { type: Array, required: true },
        selected: { type: Array, required: true },

        selectedLabel: { type: String, required: true },
        selectLabel: { type: String, required: true },
        deselectLabel: { type: String, required: true },
    },


    data() {
        return {
            value: this.options.filter(option => this.selected.includes(option.value)),
        }
    },




    /* Life cycle
    --------------------------------------------------------- */

    mounted() {
        if (!this.$el.closest('.sideform')) return

        this.korg = new Korg(this.$refs.multiselect.$refs.list, true)
        this.korg.start()
    },


    destroyed() {
        if (this.korg) {
            this.korg.stop()
        }
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {

        /* Actions
        --------------------------------------------------------- */

        open() {
            this.$refs.multiselect.activate()
        },

        rebindValue() {
            this.value = this.options.filter(option => this.selected.includes(option.value))
        },

    },

}
</script>



<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect__tag {
        height: 3.5rem;
        padding: .9rem 2.6rem .9rem 1.3rem;

        font-weight: 700;

        background: #7c57a7;
    }

    .multiselect__tag-icon:hover {
        background: none;
    }

    .multiselect__tag-icon::after {
        position: absolute;
        top: calc(50% - .9rem);
        left: calc(50% - .5rem);

        line-height: 1;
        color: #fff;
    }

    .multiselect__option::after {
        padding-right: 2rem;
    }

    .multiselect__option--highlight {
        background: #2fd276;
    }

    .multiselect__option--selected.multiselect__option--highlight {
        background: #ff2c55;
    }

    .multiselect__option--highlight::after {
        background: #2fd276;
    }

    .multiselect__option--selected.multiselect__option--highlight::after {
        background: #ff2c55;
    }

    .multiselect__content-wrapper {
        overflow-y: auto;
        overflow-y: overlay;
    }

    .multiselect__content-wrapper::-webkit-scrollbar {
        width: 1rem;

        background: transparent;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb {
        background: #5c2d91;
        border-radius: .5rem;
    }
</style>
